import flatten from 'lodash.flatten';
import isFilterEntitysId from './is-filter-entitys-id';
import getFilterProps from './get-filter-props';
import { ID } from '../constants';
const getRelationData = (entityData, relationName, currentRelationNames) => {
  if (!entityData) return null;
  if (currentRelationNames && currentRelationNames.length) {
    const arrayOfRelations = currentRelationNames.map(name => entityData[name]).filter(Boolean);
    return arrayOfRelations.length ? flatten(arrayOfRelations) : null;
  }
  return entityData[relationName];
};
const checkIfArrayHasData = (isDataArray, relationData) => isDataArray && !!relationData.length;
const setFiltersNoRelation = (isDataArray, arrayHasData, relationData, relationName) => {
  const filters = [];
  if (arrayHasData) {
    const filterValues = relationData.reduce((acc, relationValue) => {
      if (relationValue && typeof relationValue !== 'object') acc.push(`${relationName}/${relationValue}`);
      return acc;
    }, []);
    filters.push(...filterValues);
  } else if (!isDataArray && typeof relationData !== 'object') {
    filters.push(`${relationName}/${relationData}`);
  }
  return filters;
};
const buildInheritedFilters = (entityData, inheritedFilters, currentSchema, filterEntitySchema, itemId) => {
  const relationFilters = [];
  const {
    identifier: currentEntityId
  } = currentSchema;
  inheritedFilters.forEach(filter => {
    const {
      filterName,
      entityName,
      relationName,
      relationProp,
      relationEntityName,
      relationForeignKeys,
      shouldIgnoreFilter
    } = getFilterProps(filter, currentSchema, filterEntitySchema);
    const relationData = getRelationData(entityData, relationName, relationForeignKeys);
    if (currentEntityId === entityName && isFilterEntitysId(filterName, currentEntityId) || shouldIgnoreFilter) {
      relationFilters.push(`${filterName}/${itemId}`);
    }
    if (!relationData) return;
    const isDataArray = Array.isArray(relationData);
    const arrayHasData = checkIfArrayHasData(isDataArray, relationData);
    if (!relationEntityName) {
      const filtersNoRelation = setFiltersNoRelation(isDataArray, arrayHasData, relationData, filterName === ID ? filterName : relationName);
      relationFilters.push(...filtersNoRelation);
    }
    if (arrayHasData) {
      const filterValues = relationData.reduce((acc, relationValue) => {
        const filterNameToUse = filterName === ID ? 'ids' : filterName;
        if (relationValue[relationProp]) acc.push(`${filterNameToUse}/${relationValue[relationProp]}`);
        return acc;
      }, []);
      relationFilters.push(...filterValues);
    } else if (!isDataArray && relationData[relationProp]) {
      relationFilters.push(`${filterName}/${relationData[relationProp]}`);
    }
  });
  return relationFilters;
};
export default buildInheritedFilters;
//# sourceMappingURL=build-inherited-filters.js.map